export enum MealPlan {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  HALF_BOARD = 'HALF_BOARD',
  FULL_BOARD = 'FULL_BOARD',
  BREAKFAST = 'BREAKFAST',
  ROOM_ONLY = 'ROOM_ONLY',
  DISNEY_QUICK_DINING = 'DISNEY_QUICK_DINING',
  DISNEY_DINING = 'DISNEY_DINING',
  DISNEY_DELUXE = 'DISNEY_DELUXE',
}
